import { cn } from "@/lib/utils";

export function BackdropBlurTop({ className }: { className?: string }) {
	return (
		<div
			className={cn(
				"-z-10 gradual-blur isolate gradual-blur-parent h-20 absolute top-0 w-full",
				className,
			)}
			style={{
				position: "absolute",
				pointerEvents: "none",
				opacity: 1,
				height: "3.2rem",
				width: "100%",
				top: "0px",
				left: "0px",
				right: "0px",
			}}
		>
			<div className="relative w-full h-full">
				<div
					className="absolute inset-0"
					style={{
						maskImage:
							"linear-gradient(to top, transparent 0%, black 20%, black 40%, transparent 60%)",
						backdropFilter: "blur(0.25rem)",
						opacity: 1,
					}}
				/>
				<div
					className="absolute inset-0"
					style={{
						maskImage:
							"linear-gradient(to top, transparent 20%, black 40%, black 60%, transparent 80%)",
						backdropFilter: "blur(0.375rem)",
						opacity: 1,
					}}
				/>
				<div
					className="absolute inset-0"
					style={{
						maskImage:
							"linear-gradient(to top, transparent 40%, black 60%, black 80%, transparent 100%)",
						backdropFilter: "blur(0.5rem)",
						opacity: 1,
					}}
				/>
				<div
					className="absolute inset-0"
					style={{
						maskImage:
							"linear-gradient(to top, transparent 60%, black 80%, black 100%)",
						backdropFilter: "blur(0.625rem)",
						opacity: 1,
					}}
				/>
				<div
					className="absolute inset-0"
					style={{
						maskImage: "linear-gradient(to top, transparent 80%, black 100%)",
						backdropFilter: "blur(0.75rem)",
						opacity: 1,
					}}
				/>
			</div>
		</div>
	);
}

export function BackdropBlurBottom({ className }: { className?: string }) {
	return (
		<div
			className={cn(
				"z-0 absolute w-full max-h-24 inset-x-0 bottom-0 pointer-events-none",
				className,
			)}
			aria-hidden="true"
		>
			<div
				className="gradual-blur relative isolate gradual-blur-parent opacity-100"
				style={{
					position: "absolute",
					pointerEvents: "none",
					opacity: 1,
					transition: "opacity 0.3s ease-out",
					zIndex: 100,
					left: "0px",
					right: "0px",
					width: "100%",
					height: "7.5rem",
					bottom: "0px",
				}}
			>
				<div className="relative w-full h-full">
					<div
						className="absolute inset-0"
						style={{
							maskImage:
								"linear-gradient(transparent 0%, black 16.7%, black 33.3%, transparent 50%)",
							backdropFilter: "blur(0.181rem)",
							opacity: 1,
							transition: "backdrop-filter 0.3s ease-out",
						}}
					/>
					<div
						className="absolute inset-0"
						style={{
							maskImage:
								"linear-gradient(transparent 16.7%, black 33.3%, black 50%, transparent 66.7%)",
							backdropFilter: "blur(0.319rem)",
							opacity: 1,
							transition: "backdrop-filter 0.3s ease-out",
						}}
					/>
					<div
						className="absolute inset-0"
						style={{
							maskImage:
								"linear-gradient(transparent 33.3%, black 50%, black 66.7%, transparent 83.3%)",
							backdropFilter: "blur(0.5rem)",
							opacity: 1,
							transition: "backdrop-filter 0.3s ease-out",
						}}
					/>
					<div
						className="absolute inset-0"
						style={{
							maskImage:
								"linear-gradient(transparent 50%, black 66.7%, black 83.3%, transparent 100%)",
							backdropFilter: "blur(0.681rem)",
							opacity: 1,
							transition: "backdrop-filter 0.3s ease-out",
						}}
					/>
					<div
						className="absolute inset-0"
						style={{
							maskImage:
								"linear-gradient(transparent 66.7%, black 83.3%, black 100%)",
							backdropFilter: "blur(0.819rem)",
							opacity: 1,
							transition: "backdrop-filter 0.3s ease-out",
						}}
					/>
					<div
						className="absolute inset-0"
						style={{
							maskImage: "linear-gradient(transparent 83.3%, black 100%)",
							backdropFilter: "blur(0.875rem)",
							opacity: 1,
							transition: "backdrop-filter 0.3s ease-out",
						}}
					/>
				</div>
			</div>
		</div>
	);
}

export function BackdropBlurHeader() {
	return (
		<div className="absolute z-[-1] top-0 left-0 w-full h-[50px] backdrop-blur-sm bg-background/50 mask-to-t shadow-2xl" />
	);
}
